import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ContactSupport } from '@core/typings/ui/support.typing';
import { EmailExtensionValidator } from '@yourcause/common/form-control-validation';
import { AnalyticsService, EventType } from '@yourcause/common/analytics';
import { TypeSafeFormBuilder, TypeSafeFormGroup, TypeaheadSelectOption } from '@yourcause/common/core-forms';
import { YCModalComponent } from '@yourcause/common/modals';
import { PanelTypes } from '@yourcause/common/panel';

@Component({
  selector: 'gc-contact-support-modal',
  templateUrl: './contact-support-modal.component.html',
  styleUrls: ['./contact-support-modal.component.scss']
})
export class ContactSupportModalComponent extends YCModalComponent<ContactSupport.ContactSupportModalReturn> implements OnInit {
  prepopData: ContactSupport.ContactSupportModalReturn;
  formGroup: TypeSafeFormGroup<ContactSupport.ContactSupportModalReturn>;
  PanelTypes = PanelTypes;
  contactReasonPostAuthOptions: TypeaheadSelectOption<ContactSupport.ContactReasonFullList>[];

  constructor (
    private formBuilder: TypeSafeFormBuilder,
    private analyticsService: AnalyticsService
  ) {
    super();
  }

  async ngOnInit () {
    this.formGroup = this.formBuilder.group<ContactSupport.ContactSupportModalReturn>({
      reason: [this.prepopData.reason, Validators.required],
      firstName: [this.prepopData.firstName, Validators.required],
      lastName: [this.prepopData.lastName, Validators.required],
      phoneNumber: [this.prepopData.phoneNumber, Validators.required],
      companySeekingGrantFrom: [this.prepopData.companySeekingGrantFrom, Validators.required],
      applicationId: this.prepopData.applicationId,
      program: this.prepopData.program,
      organization: this.prepopData.organization,
      ein: this.prepopData.ein,
      questionDescription: [this.prepopData.questionDescription, Validators.required],
      email: [this.prepopData.email, [
        Validators.required,
        EmailExtensionValidator
      ]]
    });
  }

  onCancel () {
    this.closeModal.emit();
  }

  onSubmit () {
    const values = {
      ...this.formGroup.value
    };
    this.closeModal.emit(values);
    this.analyticsService.emitEvent({
      eventName: 'Submit support ticket',
      eventType: EventType.Click,
      extras: null
    });
  }
}
